import '@/modules/system/auth/presentation/pages/escolha-modulo.css';
import { getNavGroupIcon } from '@/shared/navigation/navigation-menu-icons';
import { Link } from 'react-router-dom';

type ProfileHomeCardProps = {
  label: string;
  description: string;
  to: string;
};

export default function ProfileHomeCard({
  label,
  description,
  to,
}: ProfileHomeCardProps) {
  const Icon = getNavGroupIcon(label);
  const descId = `home-card-desc-${label.replace(/\s+/g, '-')}`;

  return (
    <Link
      to={to}
      className="escolha-modulo-card text-decoration-none"
      aria-label={label}
      aria-describedby={descId}
    >
      <span className="escolha-modulo-card-icon">
        <Icon size={42} strokeWidth={1.35} aria-hidden />
      </span>
      <span className="escolha-modulo-card-body">
        <span className="escolha-modulo-card-title">{label}</span>
        <p id={descId} className="escolha-modulo-card-desc">
          {description}
        </p>
      </span>
    </Link>
  );
}
